import React from 'react';

import { Menu } from '@headlessui/react';
import cn from 'classnames';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { isClientAttachment } from '@entities/attachment/lib';
import { TAttachmentDTOCamelCased, TAttachmentOnClient } from '@entities/attachment/model/types';
import { getNameExtension } from '@shared/helpers';
import { UiText } from '@shared/ui';

import cls from './DnDImageList.module.css';
import { saveFile } from '../../../../TemporaryConmonents/DashboardInformation/helpers/saveFile';

interface DnDImageListProps {
    classes?: string;
    file?: TAttachmentOnClient | TAttachmentDTOCamelCased;
    onClickInputRef?: () => void;
}

export const DnDImageList = ({ classes, file, onClickInputRef }: DnDImageListProps) => {
    const { t } = useTranslation();

    const getAttachmentInfo = (file: TAttachmentOnClient | TAttachmentDTOCamelCased) => {
        const isFromClient = isClientAttachment(file);
        const isFileLoading = isFromClient ? file?.isLoading : false;
        const isImg = isFromClient
            ? file?.file?.type.startsWith('image/')
            : file?.mimeType?.startsWith('image/');
        const fileImgUrl = isFromClient ? URL.createObjectURL(file?.file) : file?.previewUrl;
        const fileName = isFromClient ? file?.file?.name : file?.name;
        const { extension: fileExtension, name } = getNameExtension(fileName);

        return {
            isFileLoading,
            isImg,
            fileImgUrl,
            fileName: name,
            fileExtension,
        };
    };

    const { fileImgUrl, fileName } = getAttachmentInfo(file);

    return (
        <div className={cn(cls.DnDImageList, [classes])}>
            <img src={fileImgUrl} alt={fileName} />
            <Menu>
                <Menu.Button
                    onClick={(event) => {
                        event.stopPropagation();
                    }}
                    className={cls.dropdown}
                >
                    <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11.2383 5.26172C11.2383 5.95207 10.6787 6.51172 9.98834 6.51172C9.29799 6.51172 8.73834 5.95207 8.73834 5.26172C8.73834 4.57136 9.29799 4.01172 9.98834 4.01172C10.6787 4.01172 11.2383 4.57136 11.2383 5.26172Z"
                            fill="#252733"
                        />
                        <path
                            d="M11.2633 10.0122C11.2633 10.7026 10.7036 11.2622 10.0133 11.2622C9.32293 11.2622 8.76329 10.7026 8.76329 10.0122C8.76329 9.32185 9.32293 8.76221 10.0133 8.76221C10.7036 8.76221 11.2633 9.32185 11.2633 10.0122Z"
                            fill="#252733"
                        />
                        <path
                            d="M11.2368 14.7617C11.2368 15.4521 10.6772 16.0117 9.98682 16.0117C9.29646 16.0117 8.73682 15.4521 8.73682 14.7617C8.73682 14.0714 9.29646 13.5117 9.98682 13.5117C10.6772 13.5117 11.2368 14.0714 11.2368 14.7617Z"
                            fill="#252733"
                        />
                    </svg>
                </Menu.Button>
                <Menu.Items className={cls.menuItems}>
                    <Menu.Item className={cls.item}>
                        <span
                            className="opacity-75"
                            onClick={(event) => {
                                event.stopPropagation();
                                onClickInputRef();
                            }}
                        >
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.42841 2.18634C8.95706 2.2333 8.50393 2.46317 8.17454 2.86544L1.76423 10.6943L1.75011 10.8378L1.50435 13.3632L1.46346 13.7323C1.44751 13.8763 1.58508 13.9889 1.72305 13.9449L2.07682 13.832L4.50413 13.0928L4.64203 13.0506L11.0523 5.2218C11.7111 4.41726 11.5962 3.26349 10.7916 2.60472C10.3893 2.27534 9.89977 2.13938 9.42841 2.18634ZM9.51392 3.04463C9.7408 3.02203 9.97978 3.10302 10.2215 3.30096C10.7031 3.69528 10.7504 4.17015 10.3561 4.65171L10.0633 4.9935L8.59348 3.78998L8.87078 3.43553C9.06873 3.19378 9.28703 3.06723 9.51392 3.04463ZM8.02339 4.48622L9.49323 5.68974L4.59048 11.6774C4.23754 11.13 3.72696 10.7119 3.12064 10.4739L8.02339 4.48622ZM2.61665 11.263C3.17832 11.4273 3.64442 11.809 3.9163 12.3272L2.46835 12.7698L2.61665 11.263Z"
                                    fill="#252733"
                                />
                                <path
                                    d="M6 13.5C6 13.2239 6.22386 13 6.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H6.5C6.22386 14 6 13.7761 6 13.5Z"
                                    fill="#252733"
                                />
                            </svg>
                            <UiText>
                                {t('DnDImageList.return.DnDImageList.Menu.Items.UiText')}
                            </UiText>
                        </span>
                    </Menu.Item>
                </Menu.Items>
            </Menu>
        </div>
    );
};
